import { HEADER } from "./_consts";

export function linkWithinPageControl() {
  const scrollLink = document.querySelectorAll('a[href^="#"]');

  // 要素が存在すればイベント登録をする
  if (scrollLink !== null) {
    for (let i = 0; i < scrollLink.length; i++) {
      scrollLink[i].addEventListener('click', scrollToAnchor.bind(scrollLink[i]), false);
    }
  }
}

function scrollToAnchor(e) {
  const hash = this.hash;
  if (hash !== '#' && hash !== '' ) {
    e.preventDefault();
    e.stopPropagation();
    const targetElement = document.getElementById(hash.replace('#', '')); // リンク先の要素（コンテンツ）
    const rect = targetElement.getBoundingClientRect().top; // ブラウザからの高さ
    const offset = window.pageYOffset; // 現在のスクロール量
    const gap = HEADER.offsetHeight; // 固定ヘッダー分の高さ
    const y = rect + offset - gap; //最終的な位置を割り出す
    window.scroll({
      top: y,
      behavior: 'smooth'
    });
  }
}